import * as React from 'react';
import { Fab, Box } from '@mui/material';
import { Add } from '@mui/icons-material';

export default function AddButton({ onClick }) {
    return (
        <Box
            sx={{
                position: 'fixed',
                bottom: '70px',
                right: '27px',
            }}
        >
            <Fab color="primary" aria-label="add" onClick={onClick}>
                <Add />
            </Fab>
        </Box>
    );
}
